import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'


const firebaseConfig = {
  apiKey: "AIzaSyAERqSDCWSfH6C5KrEGOaUmhTHxGz29T74",
  authDomain: "zombiekub.firebaseapp.com",
  projectId: "zombiekub",
  storageBucket: "zombiekub.firebasestorage.app",
  messagingSenderId: "705846073429",
  appId: "1:705846073429:web:ed1a78d71aa3cd66541cdc"
};
// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()
const projectFunctions = firebase.app().functions('asia-southeast1');


// timestamp
const timestamp = firebase.firestore.FieldValue.serverTimestamp

const FieldValue = firebase.firestore.FieldValue

export {FieldValue,projectFirestore, projectAuth, projectStorage, timestamp,projectFunctions }

